import {
   Component,
   ElementRef,
   Renderer2,
   ViewChild,
   OnInit,
   ComponentRef,
   ComponentFactoryResolver, ViewContainerRef, HostListener, OnDestroy
} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {IdexService} from 'app/idex.service';
import {Toast} from 'app/shared/toast/toast';
import {TranslateService} from '@ngx-translate/core';
import {SignTaskComponent} from '../sign-off/sign-task/sign-task.component';
import {Mimetype} from '../../shared/mimetype';
import {PdfRenditionWatcher} from '../../shared/pdf-rendition-watcher';
import {MomentPipe} from '../../shared/moment.pipe';
import {DocTypeComponent} from '../../shared/doctype.component';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {DeleteCommentComponent} from '../../dms/delete-comment/delete-comment.component';
import {DomSanitizer} from '@angular/platform-browser';
import {ThumbnailComponent} from './thumbnail/thumbnail.component';
import { EformAPI } from 'app/e-form/e-form.api';
import { EformService } from 'app/e-form/service/eform.service';
import { Section } from 'app/e-form/model/eform-type';
import { TaskAttribute } from '../create-task/create-task.type';

declare let $: any;

export interface ImageData {
   itemImgThumbnail: TtemImageThumbnail[];
   lastPageLoaded: number;
}

export interface TtemImageThumbnail {
   docId: string;
   pageNo: number;
   isLoad: boolean;
}

@Component({
   selector: 'app-sign-document',
   templateUrl: './sign-document.component.html',
   styleUrls: ['./sign-document.component.css', '../../../assets/font_stylesheet.css']
})
export class SignDocumentComponent implements OnInit, OnDestroy {
   doc: any;
   docId: any;
   show: boolean;
   item: any;
   public checkselectedItems: any = [];
   public selectedItems: any = [];
   settype = false;
   types: any[];
   saveText = 'Save';
   form: any;
   lastModified: any;
   comment: any;
   post = 'ส่ง';
   taskId: number;
   status: string;
   sender: any;
   email: any;
   isSender: boolean;
   flagpage = true;
   flagCheckSelect = false;
   public sections: Section[];
   lang: string;
   docType: any;
   isShowThumbnail = false;
   isFormName = false;

   isAddMetadata = true;
   checkStatus: string;
   public messageWarning: string;
   public selectButton = false;
   public selectedTab = 1;
   public imgThumbnails: ImageData[] = [];
   /** เลิกรับผลการแปลงจาก watcher ของ signTaskComp (thumbnail ไม่ poll เอง) */
   private unsubscribeThumbnailReady: () => void;
   public totalPages: any;
   private dpi = 20;
   public thumbnailSelected = [];
   public dataWidthHeight: any;
   public dataWidthHeightAll: any;
   public pageSelectDelete: any;
   public typeNames: any;
   public taskStatus: string;
   public taskName: string;
   public taskAttribute: TaskAttribute = {
      taskId: 0,
      taskName: '',
      dueDate: null,
      priority: 0,
      templateId: 0,
      workflowId: 0,
      currentLevel: 1,
      apvLevel: [],
      docList: [],
      message: ''
   };
   public formName;
   public docName;
   public isThumbnailLoadFinish = false;
   public device;
   private componentRef1: ComponentRef<{}>;
   private componentRef2: ComponentRef<{}>;
   public isToggleLeftOpened = true;
   public isToggleRightOpened = true;
   @ViewChild(SignTaskComponent, { static: true }) public signTaskComp: SignTaskComponent;
   @ViewChild(ThumbnailComponent, { static: true }) public ThumbnailComp: ThumbnailComponent;
   @ViewChild('btnAction') btnAction;
   @ViewChild('info') info: ElementRef;
   @ViewChild('tools') tools: ElementRef;
   @ViewChild('form1', {read: ViewContainerRef}) form1: ViewContainerRef;
   @ViewChild('form2', {read: ViewContainerRef}) form2: ViewContainerRef;
   @ViewChild('fileUpload') fileUpload: ElementRef;

   public maxIndex = -1;
   public selectDelItems: any[] = [];
   public isOnDownloadDoc = false;
   public value: any;
   public key: string;
   public isExtSign = false;

   constructor(private route: ActivatedRoute,
               public service: IdexService, private toast: Toast,
               private router: Router,
               private translate: TranslateService,
               private renderer: Renderer2,
               private resolver: ComponentFactoryResolver,
               private sanitizer: DomSanitizer,
               private dialog: MatDialog,
               public eFormService: EformService,
               private eform: EformAPI) {
               this.service.loadFileMaxUpload();
   }

   @HostListener('window:beforeunload', ['$event'])
   unload($event: any) {
      localStorage.setItem('idex-user', JSON.stringify(this.service.user))
   }

   ngOnInit() {
      this.eFormService.initailization();
      this.signTaskComp.leftPanelComp.typeName = 'signTask';
      this.route.params.forEach((params: Params) => {
         this.taskId = params['taskid'];
         this.signTaskComp.viewDocumentComp.taskId = this.taskId;
         this.device = params['device'];
         this.lang = this.translate.currentLang;
         this.key = params['key'];

         if(this.key) {
            this.isExtSign = true;
         }

         if (this.device !== 'mobile' || this.key) {
            this.openTask();
         } else {
            if (localStorage.getItem('first_sign') === 'true') {
               this.checkDevice('idex://signdoc?key=' + this.taskId + '&idex-user-firstsign=' +
                  JSON.stringify(this.service.user), this.taskId);
            } else {
               this.checkDevice('idex://signdoc?key=' + this.taskId, this.taskId);
            }
         }
      });
   }

   /**
    * Call Service OpenTask
    */
   openTask() {
      this.service.openTask(this.taskId)
         .subscribe((response) => {
               if (response.taskStatus === 'unauthorized') {
                  this.translate.get('alert.unauthorized').subscribe(s => {
                     this.toast.error(s);
                     if (this.key) {
                        this.router.navigate(['/login']);
                     } else {
                        if (sessionStorage.getItem('taskPath')) {
                           this.router.navigate([sessionStorage.getItem('taskPath')]);
                        } else {
                           this.router.navigate(['/tasks/sign']);
                        }
                     }
                  });
               } else {
                  this.service.getTask(this.taskId, true)
                     .subscribe(async (res) => {
                           this.checkStatus = res.taskStatus;
                           this.taskStatus = response.taskStatus;
                           this.email = this.service.user.email;
                           this.sender = res.senderEmail;
                           this.isSender = this.email === this.sender;
                           if (this.taskStatus === 'sign') {
                              res.taskStatus = 'Need to sign';
                           }
                           this.taskAttribute = res; // set initail res for sign page
                           for (const level of this.taskAttribute.apvLevel) {
                              const signer = level.signerList.filter(signer => (signer.signerEmail.toLowerCase() === this.service.user.email || signer.reassignEmail.toLowerCase() === this.service.user.email || signer.originatorEmail.toLowerCase() === this.service.user.email) && signer.stepOrder === res.currentLevel);
                              if (signer.length > 0) {
                                 this.signTaskComp._taskContactId = signer[0].taskContactId;
                                 break;
                              }
                           }
                           for (let i = 0; i < this.taskAttribute.docList.length; i++) {
                              if (this.getTypeByName(this.taskAttribute.docList[i].docName) === 'zdox') {
                                 this.isFormName = true;
                                 this.signTaskComp.fileFormName = this.taskAttribute.docList[i].docName;
                              }
                              if (this.taskAttribute.docList[0].isAttachFile) {
                                 this.taskAttribute.docList.push(this.taskAttribute.docList[0]);
                                 this.taskAttribute.docList.splice(0, 1);
                              } else {
                                 break;
                              }
                           }
                           this.taskName = res.taskName;
                           this.signTaskComp.siteId = res.siteId;
                           this.signTaskComp.getWatermark();
                           this.signTaskComp.taskAttribute = res;
                           this.signTaskComp.leftPanelComp.taskAttribute = res;
                           this.signTaskComp.leftPanelComp.signListComp.documents = res.docList;
                           this.signTaskComp.leftPanelComp.isHideSigner = response.isSign;
                           this.signTaskComp.isHideAction = !response.isSign;
                           this.signTaskComp.leftPanelComp.signListComp.setSignList(0, 'signTask');
                           if (this.signTaskComp.signerSelected === this.signTaskComp.leftPanelComp.toolsComp && this.signTaskComp.mimType === 'application/pdf') {
                              this.signTaskComp.signerSelected = this.signTaskComp.leftPanelComp.toolsComp
                                 .addNewSigner(this.taskAttribute.apvLevel);
                           }
                           const docList = [];
                           docList.push();
                           for (const document of this.taskAttribute.docList) {
                              docList.push(document.docId);
                           }
                           this.getThumbnail(docList);
                           this.signTaskComp.changeDrawPage(this.signTaskComp.currentIndex, true); // call changeDrawPage to call page
                        },
                        err => {
                           console.error(err);
                        });
               }
            },
            err => {
               console.error(err);
            });
   }

   back() {
      if (this.taskAttribute.taskId && this.taskAttribute.taskId !== 0) {
         this.service.closeTask(this.taskAttribute.taskId).subscribe();
      }

      if (this.key) {
         this.router.navigate(['/login']);
      } else {
         this.signTaskComp.closePage();
      }
   }

   /**
    * Toggle Menu
    */
   toggleRight(): void {
      if (this.info) {
         if (this.info.nativeElement.className.indexOf('slide-right') === -1) {
            this.renderer.addClass(this.info.nativeElement, 'slide-right');
            this.isToggleRightOpened = false;
            if (!this.signTaskComp.isZoom && this.signTaskComp._isVisible !== 'visible' && !this.signTaskComp._isComment) {
               this.signTaskComp.handleFitPage(true);
            }
            if (this.isToggleLeftOpened) {
               this.signTaskComp.setHeaderWidth(this.checkWidth('T1'));
            } else {
               this.signTaskComp.setHeaderWidth(this.checkWidth('T2'));
            }
         } else {
            this.renderer.removeClass(this.info.nativeElement, 'slide-right');
            this.isToggleRightOpened = true;
            if (!this.signTaskComp.isZoom && this.signTaskComp._isVisible !== 'visible' && !this.signTaskComp._isComment) {
               this.signTaskComp.handleFitPage(false);
            }
            if (this.isToggleLeftOpened) {
               this.signTaskComp.setHeaderWidth(this.checkWidth('T3'));
            } else {
               this.signTaskComp.setHeaderWidth(this.checkWidth('T4'));
            }
         }
         if (!this.signTaskComp._isComment) {
            this.signTaskComp.deselectAll();
         }
         this.signTaskComp._isComment = false;
         this.signTaskComp.setLeftComment();
      }
   }

   toggleLeft(): void {
      this.signTaskComp.drawer.toggle(this.signTaskComp.navChange(this, this.signTaskComp.drawer));
      this.isToggleLeftOpened = this.signTaskComp.drawer.opened;
      if (this.isToggleLeftOpened) {
         if (this.isToggleRightOpened) {
            this.signTaskComp.setHeaderWidth(this.checkWidth('T3'));
         } else {
            this.signTaskComp.setHeaderWidth(this.checkWidth('T1'));
         }
      } else {
         if (this.isToggleRightOpened) {
            this.signTaskComp.setHeaderWidth(this.checkWidth('T4'));
         } else {
            this.signTaskComp.setHeaderWidth(this.checkWidth('T2'));
         }
      }
      this.signTaskComp.deselectAll();
      this.signTaskComp.setLeftComment();
   }

   /**
    * CheckWidth device for responsive
    */
   checkWidth(size) {
      if (size === 'T1' || size === 'T3') {
         return 250;
      } else  {
         return 0;
      }
   }

   /**
    * call back when listclick in signpage
    */
   onListClick($event): void {
      this.selectedTab = 0;
      this.docId = $event;
      if (this.signTaskComp.dynamicFormComp) {
         const formValue = this.signTaskComp.dynamicFormComp.form.value;
         const values = {...JSON.parse(this.value || '{}'), ...formValue};
         this.eFormService.eForm.value.value = values;
         this.eFormService.storeValue(values);
         this.value = JSON.stringify(values);
         this.eFormService.statusForm = this.signTaskComp.dynamicFormComp.form.status;
      }
      const indexForm = this.taskAttribute.docList.findIndex(o => o.docName.toLowerCase().endsWith('.zdox'));
      if (indexForm > -1) {
         this.createFormSections(this.taskAttribute.docList[indexForm].docId);
      }
      this.getDocument($event);
      if (this.signTaskComp._dataPages !== undefined && this.signTaskComp._dataPages.length > 0) {
         this.signTaskComp.setDocId($event);
         this.totalPages = this.signTaskComp._dataPages[this.signTaskComp.currentIndex].totalPages;
         this.dataWidthHeight = this.signTaskComp._dataPages[this.signTaskComp.currentIndex].pages;
         this.dataWidthHeightAll = this.signTaskComp._dataPages[this.signTaskComp.currentIndex].pages;
         this.setInitialThumbnail();
      }
   }

   /**
    * get document info for menu right side
    */
   getDocument(docId): void {
      this.service.getDocumentAdmin(docId, this.taskId, 'task')
         .subscribe((data: any) => {
               if (data) {
                  let ext = data.name.split('.').pop();
                  if (ext.toLowerCase() === 'zdox' || data.mimeType === 'text/xml') {
                     this.isShowThumbnail = false;
                  } else {
                     this.isShowThumbnail = true;
                  }
                  this.doc = data;
                  if (this.doc.typeName) {
                     this.typeNames = this.doc.typeName;
                  }
                  this.doc.description = data.description;
                  this.comment = data.comments;
                  this.show = Mimetype.canEdit(this.doc);
                  const fmt = new MomentPipe();
                  this.lastModified = {when: fmt.transform(this.doc.modified)};
                  if (!data.typeName) {
                     if (this.isExtSign) {
                        this.service.getShareTypes().subscribe(dataType => {
                           this.types = dataType;
                        });
                     } else {
                        this.service.getTypes().subscribe(dataType => {
                           this.types = dataType;
                        });
                     }
                     this.isAddMetadata = false;
                     this.settype = false;
                  } else if (data.typeName) {
                     this.settype = true;
                     this.isAddMetadata = true;
                     setTimeout(() => {
                        if (this.doc.properties) {
                           this.componentRef1 = DocTypeComponent.create(this.resolver, this.componentRef1, this.form1, this.doc.properties);
                        }
                     }, 200);
                  }

               }
            },
            (error: any) => {
               // This is intentional.
            });
   }

   /**
    * set data comment
    */
   getComment(): void {
      this.service.getComment(this.docId).subscribe(
         data => {
            this.comment = data.items;
         });
   }

   postComment(button: MatButton, input: any): void {
      const text = input.value.trim();
      if (text.length === 0) {
         input.focus();
         return;
      }
      button.disabled = true;
      this.translate.get('sending').subscribe(s => {
         this.post = s;
      });
      this.service.postComment(this.docId, text, this.taskId).subscribe(
         () => {
            input.value = '';
            this.translate.get('sended').subscribe(s => {
               this.post = s;
            });
            this.getComment();
            setTimeout(() => {
               button.disabled = false;
               this.translate.get('send').subscribe(s => {
                  this.post = s;
               });
            }, 3000);
         },
         error => {
            button.disabled = false;
            this.translate.get('send').subscribe(s => {
               this.post = s;
            });
         });
   }

   delComment(item: any): void {
      const dialogRef = this.dialog.open(DeleteCommentComponent, {
         disableClose: true,
         data: {service: this.service, item: item}
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const i = this.comment.indexOf(item);
            if (i !== -1) {
               this.comment.splice(i, 1);
            }
         }
      });
   }

   editComment(item: any) {
      item.editing = true;
      setTimeout(() => {
         $('#edit-' + item.id).focus();
      }, 200);
   }

   saveComment(item: any, input: any) {
      if (input.value.trim().length === 0) {
         return;
      }
      let url;
      if (this.taskId) {
         url = '/comments/' + item.id + '/' + this.docId + '?taskId=' + this.taskId;
      } else {
         url = '/comments/' + item.id + '/' + this.docId;
      }
      this.service.put(url, {content: encodeURIComponent(input.value)})
         .subscribe(res => {
            item.editing = false;
            item.content = input.value;
         });
   }

   transform(value) {
      return this.sanitizer.bypassSecurityTrustHtml(value);
   }

   loadForm(name: string) {
      this.form = undefined;
      this.service.getType(name).subscribe(data => {
         this.form = data;
         this.componentRef2 = DocTypeComponent.create(this.resolver, this.componentRef2, this.form2, data);
      });
   }

   saveType(button: any, type: any) {
      const data = {type: type, properties: this.getProperties(this.form)};
      if (!data.properties) {
         return;
      }
      button.disabled = true;
      this.saveText = 'Saving...';
      this.service.setSignDocType(this.doc.id, data).subscribe(value => {
         this.doc.typeName = type.viewValue;
         this.doc.properties = value;
         this.saveText = 'Saved';
         setTimeout(() => {
            button.disabled = false;
            this.saveText = 'Save';
         }, 5000);
      });
   }

   saveProperties(button: MatButton) {
      const properties = this.getProperties(this.doc.properties);
      if (!properties) {
         return;
      }
      button.disabled = true;
      this.saveText = 'Saving...';
      this.service.setSignDocMetadata(this.doc.id, properties).subscribe(data => {
         this.doc.properties = data;
         this.saveText = 'Saved';
         setTimeout(() => {
            button.disabled = false;
            this.saveText = 'Save';
         }, 5000);
      });
   }

   private getProperties(form: any[]) {
      const error = function (e, msg) {
         e.focus();
         return null;
      };
      const properties = {};
      for (let i = 0; i < form.length; i++) {
         const f = form[i];
         const e = $('#' + f.name.replace(':', '_'));
         const value = e.val();
         if (f.mandatory && !value) {
            return error(e, f.label + ' is required');
         }
         if (f.constraints && value) {
            if (f.constraints.minLength && value.length < f.constraints.minLength) {
               return error(e, 'Minimum length of ' + f.label + ' is ' + f.constraints.minLength + ' characters');
            }
            if (f.constraints.maxLength && value.length > f.constraints.maxLength) {
               return error(e, 'Maximum length of ' + f.label + ' is ' + f.constraints.maxLength + ' characters');
            }
            if (f.constraints.minValue !== undefined && value < f.constraints.minValue) {
               return error(e, 'Minimum value of ' + f.label + ' is ' + f.constraints.minValue);
            }
            if (f.constraints.maxValue !== undefined && value > f.constraints.maxValue) {
               return error(e, 'Maximum value of ' + f.label + ' is ' + f.constraints.maxValue);
            }
            if (f.constraints.expression && !new RegExp(f.constraints.expression).test(value)) {
               return error(e, 'Value of ' + f.label + ' did not match the pattern');
            }
         }
         properties[f.name] = value;
      }
      return properties;
   }

   saveDescription(e: Event): void {
      const input = <HTMLTextAreaElement>e.target;
      if (input.value !== this.doc.description) {
         // TODO: call PUT /description { id: this.doc.id, description: input.value }
         this.doc.description = input.value;
         this.service.updateDescription(input.value, this.docId)
            .subscribe(
               data => {
                  // This is intentional.
               },
               error => {
                  console.error(error);
               });
      }
   }

   onSelectedChange($event) {
      this.selectedTab = $event;
   }

   /**
    * Get Thumbnails data
    */
   ngOnDestroy() {
      this.unsubscribeThumbnailReady?.();
   }

   /** สร้างข้อมูล thumbnail ของเอกสารตำแหน่ง indexDoc (เรียกซ้ำได้เมื่อไฟล์แปลงเสร็จภายหลัง) */
   private buildThumbnailEntry(data, indexDoc) {
      const itemImgThumbnail = [];
      for (let i = 0; i < data[indexDoc].totalPages; i++) {
         itemImgThumbnail.push({
            docId: data[indexDoc].docId,
            pageNo: i + 1,
            isLoad: false,
         });
         this.checkselectedItems[i] = false;
      }
      this.imgThumbnails[indexDoc] = {
         itemImgThumbnail: itemImgThumbnail,
         lastPageLoaded: 0
      };
      if (this.imgThumbnails[indexDoc].itemImgThumbnail.length <= 4) {
         this.setInitialLoadThumbnail(this.imgThumbnails[indexDoc].itemImgThumbnail.length, indexDoc);
      } else {
         this.setInitialLoadThumbnail(5, indexDoc);
      }
   }

   getThumbnail(docList) {
      this.signTaskComp.handleWaitAction(true);
      const taskId = this.taskId;
      this.service.transformPdfThumbnails(docList, this.dpi, taskId, true).subscribe((data) => {
            if (data.length > 0) {
               this.imgThumbnails = [];
               this.dataWidthHeight = data[this.signTaskComp.currentIndex].pages;
               this.dataWidthHeightAll = data[this.signTaskComp.currentIndex].pages;
               this.thumbnailSelected = [];
               this.totalPages = data[0].totalPages;
               for (let indexDoc = 0; indexDoc < data.length; indexDoc++) {
                  this.buildThumbnailEntry(data, indexDoc);
               }
               // ไฟล์ที่ยังแปลงไม่เสร็จ: เติม thumbnail ทีละไฟล์เมื่อพร้อม โดยรับผลจาก watcher ของหน้าเอกสาร
               // (เอกสารชุดเดียวกัน จึงไม่ poll ซ้ำเอง ลด request ลงครึ่งหนึ่ง)
               this.unsubscribeThumbnailReady?.();
               this.unsubscribeThumbnailReady = undefined;
               if (data.some(doc => PdfRenditionWatcher.isConverting(doc))) {
                  this.unsubscribeThumbnailReady = this.signTaskComp.renditionWatcher.subscribeReady(doc => {
                     const i = data.findIndex(item => item?.docId === doc.docId);
                     if (i < 0 || !PdfRenditionWatcher.isConverting(data[i])) {
                        return;
                     }
                     data[i] = doc;
                     this.buildThumbnailEntry(data, i);
                     // ค่าเหล่านี้ใช้กับเอกสารที่เปิดอยู่ (เช่น totalPages <= 2 จะซ่อน scroll ของ thumbnail)
                     if (i === this.signTaskComp.currentIndex) {
                        this.totalPages = doc.totalPages;
                        this.dataWidthHeight = doc.pages;
                        this.dataWidthHeightAll = doc.pages;
                     }
                  });
               }
               if (data[this.signTaskComp.currentIndex].canTransform === false &&
                   data[this.signTaskComp.currentIndex].docId && this.docType === 'zdox') {
                     this.createFormSections(data[this.signTaskComp.currentIndex].docId);
               }
            }

            this.isThumbnailLoadFinish = true;
            this.handleWaitAction();
         },
         (err) => {
            this.isThumbnailLoadFinish = true;
            this.handleWaitAction();
            console.error(err);
         });
   }

   createFormSections(docId: string): void {
      this.eform.getEFormFormDocId(docId).subscribe((eformData) => {
         const _transformDate = new MomentPipe();

         if (eformData) {
            const data = eformData.body.data;
            this.isFormName = true;

            this.eFormService.initailization();
            this.eFormService.eForm.controls.original.setValue(this.lang);
            this.eFormService.formValue.id = data.formId;
            this.eFormService.formValue.docId = docId;
            this.eFormService.formValue.original = this.lang;
            this.eFormService.formValue.lastUpdate = {when: _transformDate.transform(data.lastUpdate)};
            this.eFormService.formValue.version = data.version;

            for(let section  of data.sections){
               section['fieldNames'] = section.fields.map(o => o.fieldName);
            }

            this.eFormService.storeMetaField(data.formName, data.key);
            this.eFormService.storeSection(data.sections);
            if (this.value) {
               this.eFormService.storeValue(this.value ?  JSON.parse(this.value) : '');
               this.eFormService.formValue.value = JSON.parse(this.value);
            } else {
               this.value = data.value;
               this.eFormService.storeValue(data.value ?  JSON.parse(data.value) : '');
               if (data.value) {
                  this.eFormService.formValue.value = JSON.parse(data.value);
               }
            }
            this.setFormName(data);
            const val = this.value ? JSON.parse(this.value) : '';
            if (data.sections.length > 0) {
               this.sections = data.sections;
               for (let indexSection = 0; indexSection < this.sections.length; indexSection++) {
                  const fieldsLength = this.sections[indexSection].fields.length;
                  for (let indexField = 0; indexField < fieldsLength; indexField++) {
                     if (this.sections[indexSection].fields[indexField].fieldName === '') {
                        this.sections[indexSection].fields[indexField].fieldNameEmpty = 'fieldName' + indexSection + indexField;
                     }
                  }
               }
            }
         }
      });
   }

   onClickButtonAll($event) {
      if ($event.checked) {
         this.selectButton = true;
         this.checkAllSelected(this.thumbnailSelected, true);
         this.ThumbnailComp.checkButtonAll($event);
      } else {
         this.selectButton = false;
         this.checkAllSelected(this.thumbnailSelected, false);
         this.ThumbnailComp.checkButtonAll($event);
      }
      this.pageSelectDelete = this.ThumbnailComp.getMaxPage();
   }

   checkAllSelected(item, checked) {
      for (let i = 0; i < item.length; i++) {
         item[i].isSelected = checked;
      }
   }

   /**
    * Callback warppage to page do you want
    */
   wrapPage(pageNo) {
      this.signTaskComp.warpPage(pageNo);
   }

   /**
    * Callback thumbnail refresh thumbnail data
    */
   onGetThumbnail(docList) {
      this.flagCheckSelect = false;
      this.getThumbnail(docList);
   }

   onSelectFiles($event, input: any) {
      if (input.files.length === 0) {
         return;
      }
      this.fileUpload.nativeElement.value = ''; // clear file name after upload
   }

   validateFile(myFile: any) {
      const $input = $('input[type=file]');
      if (myFile.length > 1) {
         $input.val('');
         $input.attr('title', window.URL ? ' ' : '');
         this.handleToastError('uploadDoc.errorSelectFile');
         return false;
      }

      for (let i = 0; i < myFile.length; i++) {
         if (myFile[i] != null) {
            const ext = myFile[i].type;
            if (ext !== '') {
               if (this.validateExtension(ext) === false) {
                  $input.val('');
                  $input.attr('title', window.URL ? ' ' : '');
                  this.handleToastError('uploadDoc.errorPdf');
                  return false;
               } else {
                  if (myFile[i].size > this.service.fileMaxUpload) { // 2097152
                     $input.val('');
                     $input.attr('title', window.URL ? ' ' : '');
                     this.translate.get('uploadDoc.errorFileSize', {size: this.service.getFileMaxUploadMB()}).subscribe(s => this.toast.error(s));
                     return false;
                  }
               }
            } else {
               $input.val('');
               $input.attr('title', window.URL ? ' ' : '');
               this.handleToastError('uploadDoc.errorPdf');
               return false;
            }
         }
      }
      return true;
   }

   validateExtension(v) {
      const allowedExtensions = new Array('application/pdf');

      for (let ct = 0; ct < allowedExtensions.length; ct++) {
         const fileSelected = v.toLowerCase().lastIndexOf(allowedExtensions[ct]);
         if (fileSelected !== -1) {
            return true;
         }
      }
      return false;
   }

   handleToastError(key) {
      this.translate.get(key).subscribe((msg) => {
         this.toast.error(msg);
      });
   }

   /**
    * Callback when select item in thumbnail check logic for select or unselect
    */
   onCheckSelect(select) {
      this.flagCheckSelect = false;
      if (select.select === -1) {
         for (let j = 0; j < this.totalPages; j++) {
            this.checkselectedItems[j] = true;
         }
      } else if (select.select === -2) {
         for (let i = 0; i < this.totalPages; i++) {
            this.checkselectedItems[i] = false;
         }
      } else {
         this.checkselectedItems[select.select] = select.status;
      }
      for (let k = 0; k < this.totalPages; k++) {
         if (this.checkselectedItems[k] === true) {
            this.flagCheckSelect = true;
         }
      }
   }

   onCheckUnSelectAll() {
      this.selectButton = false;
   }

   checkDevice(path, taskId) {
      const userAgent = navigator.userAgent.toLowerCase();
      const tempUser = this.service.user;
      if (userAgent.search('iphone') > -1) {
         window.location.href = path;
         setTimeout(function() {
            window.location.href = 'https://itunes.apple.com/app/zdox/id1436468541';
         }, 5000);
      } else if (userAgent.search('android') > -1) {
         window.location.href = path;
         setTimeout(function (user) {
            if (localStorage.getItem('first_sign') === 'true') {
               window.location.href = 'https://play.google.com/store/apps/details?id=com.ginkgosoft.idex&referrer=signdoc?key='
                  + taskId + '&idex-user-firstsign=' + JSON.stringify(user);
            } else {
               window.location.href = 'https://play.google.com/store/apps/details?id=com.ginkgosoft.idex&referrer=signdoc?key='
                  + taskId;
            }
         }, 1000, tempUser);
      } else {
         this.openTask();
      }
   }

   onScrollTum(page) {
      if (this.isToggleRightOpened) {
         if (this.ThumbnailComp) {
            this.ThumbnailComp.scroll(page);
         }
      }
   }

   handleWaitAction() {
      if (this.isThumbnailLoadFinish) {
         if (this.signTaskComp.isPageLoadFinish) {
            this.signTaskComp.handleWaitAction(false);
            this.signTaskComp.isPageLoadFinish = false;
            this.isThumbnailLoadFinish = false;
         }
      }
   }

   onClickDownloadAll() {
      this.isOnDownloadDoc = true;
      this.signTaskComp.viewDocumentComp.downloadAll(this.checkStatus === 'Completed');
   }

   onClickDownloadCombine() {
      this.isOnDownloadDoc = true;
      this.signTaskComp.viewDocumentComp.downloadCombine(this.taskName,this.checkStatus === 'Completed');
   }

   setEnableDownloadAll() {
      this.isOnDownloadDoc = false;
   }

   /**
    * handle when scroll in sign page
    */
   onScrollThumbnails(event) {
      const lastPageLoaded = this.imgThumbnails[this.signTaskComp.currentIndex].lastPageLoaded;
      const scrollTop = $(event.target)[0].scrollTop;
      const heightBody = $(event.target)[0].clientHeight;
      const heightChild = $($(event.target)[0]).children()[0].clientHeight;
      const heightChildAll = heightChild * lastPageLoaded;
      if (Math.ceil((heightBody + scrollTop)) >= heightChildAll) {
         if (this.imgThumbnails[this.signTaskComp.currentIndex].itemImgThumbnail.length > lastPageLoaded) {
            this.imgThumbnails[this.signTaskComp.currentIndex].itemImgThumbnail[lastPageLoaded].isLoad = true;
            this.imgThumbnails[this.signTaskComp.currentIndex].lastPageLoaded++;
         }
      }
   }

   setInitialLoadThumbnail(num, index) {
      for (let count = 0; count < num; count++) {
         this.imgThumbnails[index].itemImgThumbnail[count].isLoad = true;
      }
      this.imgThumbnails[index].lastPageLoaded = num;
   }

   setInitialThumbnail() {
      const index = this.signTaskComp.currentIndex;
      if (this.imgThumbnails.length > 0) {
         if (this.imgThumbnails[index].itemImgThumbnail !== undefined && this.imgThumbnails[index].itemImgThumbnail.length > 0) {
            this.imgThumbnails[index].itemImgThumbnail = this.imgThumbnails[index].itemImgThumbnail.map((item) => ({
                  ...item,
                  isLoad: false,
               })
            );
         }
         if (this.imgThumbnails[index].itemImgThumbnail.length < 3) {
            for (let count = 0; count < this.imgThumbnails[index].itemImgThumbnail.length; count++) {
               this.imgThumbnails[index].itemImgThumbnail[count].isLoad = true;
               this.imgThumbnails[index].lastPageLoaded = count;
            }
         } else {
            this.imgThumbnails[index].itemImgThumbnail[0].isLoad = true;
            this.imgThumbnails[index].itemImgThumbnail[1].isLoad = true;
            this.imgThumbnails[index].itemImgThumbnail[2].isLoad = true;
            this.imgThumbnails[index].lastPageLoaded = 3;
         }
      }
   }
   updatefile(value) {
      const docList = [];
      for (const document of this.taskAttribute.docList) {
         docList.push(document.docId);
      }
      if (value.action === 'insert') {
         this.getThumbnail(docList);
         this.signTaskComp.changeDrawPage(this.signTaskComp.currentIndex, false);
      } else {
         this.signTaskComp.leftPanelComp.attachComp.checkDelete = true;
         if (this.signTaskComp.currentIndex === this.taskAttribute.docList.length ) {
            this.signTaskComp.currentIndex = this.signTaskComp.currentIndex - 1;
         }
         this.getThumbnail(docList);
         this.signTaskComp._dataPages.splice(value.order, 1);
         this.signTaskComp.setDocId(this.taskAttribute.docList[this.signTaskComp.currentIndex].docId);
         this.totalPages = this.signTaskComp._dataPages[this.signTaskComp.currentIndex].totalPages;
         this.signTaskComp.refreshPage(this.signTaskComp.currentIndex);
         setTimeout(() => {
            this.signTaskComp.leftPanelComp.attachComp.checkDelete = false;
         }, 1000);
      }
   }

   setFormName(data:any){
      switch(this.lang) {
         case 'th': {
            this.formName =  data.formName.th;
            break;
         }
         case 'cn': {
            this.formName =  data.formName.cn;
            break;
         }
         default: {
            this.formName =  data.formName.en;
         }
      }
   }

   getTypeByName(name: string) {
      if (name) {
         const lenght = name.split('.').length;
         const nameArray = name.split('.');
         return nameArray[lenght-1]
      }
   }
}
